import { useState, useCallback } from 'react';
import API from 'api/api';
import { translateApiError } from 'i18n/translateApiError';

export default function useChangeClientVIPStatus ({ onSettled } = {}) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const changeClientVIPStatus = useCallback(
    async (clientId, isVIP) => {
      if (!clientId) {
        setError('Client ID is required');
        return false;
      }

      setLoading(true);
      setError(null);

      try {
        await API.put(`/users/${clientId}/vip-status`, {
          isVIP : isVIP
        });

        if (onSettled) {
          onSettled();
        }

        return true;
      } catch (err) {
        setError(
          translateApiError(err, 'Failed to mark client as VIP'),
        );

        if (onSettled) {
          onSettled();
        }

        return false;
      } finally {
        setLoading(false);
      }
    },
    [onSettled],
  );

  return {
    changeClientVIPStatus,
    loading,
    error,
  };
}
